import { render } from "./TeacherDashboard.vue?vue&type=template&id=bf86bee8&scoped=true"
import script from "./TeacherDashboard.vue?vue&type=script&lang=js"
export * from "./TeacherDashboard.vue?vue&type=script&lang=js"

import "./TeacherDashboard.vue?vue&type=style&index=0&id=bf86bee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf86bee8"]])

export default __exports__